<template>
    <div>
        <card-header title='New Quote' icon="fa-plus"/>

        <card-body>
            <quote-form :quote="quote" @loading="loading"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="isButtonDisabled"
                    ><i class="fas fa-plus mr-2"></i>New Quote</b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import QuoteForm from "@/cards/reseller/QuoteForm";

    import {client as http} from '../../http_client';

    export default {
        components: {QuoteForm, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                quote: {
                    enrollmentType: 'payment_plan',
                    title: 'Payment Plan for Courses',
                    status: 'DRAFT',
                    hours: 0,
                    down: 0,
                    courses: [],
                    user: null,
                    defer_day: 1,
                    defer_year: null,
                    valid: false,
                    verifiedContact: false,
                }
            }
        },
        computed: {
            isButtonDisabled() {
                if (this.quote.enrollmentType === 'cart_enrollment') {
                    // Cart enrollment: just need user and clock hours > 0
                    return !this.quote.user || !this.quote.hours || this.quote.hours <= 0;
                } else {
                    // Payment plan: full validation including term >= 2 and <= 36
                    return !this.quote.valid || !this.quote.user || !this.quote.title || this.quote.hours < 10 || !this.quote.term || !this.quote.defer_month || !this.quote.defer_day || !this.quote.defer_year || this.quote.term < 2 || this.quote.term > 36 || !this.quote.total || this.quote.total <= 0;
                }
            }
        },
        methods: {
            submit: function() {
                this.$emit('loading', true);

                // Save user contact information
                const userId = this.quote.user.id;
                const userUpdateData = {
                    email: this.quote.user.email,
                    email_2: this.quote.user.email2 || null,
                    phone: this.quote.user.phone,
                    phone_2: this.quote.user.phone2 || null,
                    address: this.quote.user.address,
                    address_2: this.quote.user.address2 || null,
                    city: this.quote.user.city,
                    state: this.quote.user.state,
                    zip: this.quote.user.zip
                };

                // Update user information
                http.put('users/' + userId, userUpdateData).then(() => {
                    // Now create the quote
                    this.quote.user_id = this.quote.user.id;
                    delete this.quote.user;

                    this.quote.course_choices = [];
                    for (let i = 0; i < this.quote.courses.length; i++) {
                        let course = this.quote.courses[i];
                        this.quote.course_choices.push({
                            course_id: course.course_id,
                            course_name: course.course_name,
                            config_id: course.config_id,
                            custom1: course.custom1,
                            custom2: course.custom2
                        });
                    }
                    this.quote.course_choices = JSON.stringify(this.quote.course_choices);
                    delete this.quote.courses;

                    http.post('quotes/', this.quote, {force: true}).then(response => {
                        this.$reloadCard('reseller-quotes');
                        this.$closeCard(this.card);
                    }).catch(err => {
                        console.error('Error creating quote:', err);
                        this.$emit('loading', false);
                    });
                }).catch(err => {
                    console.error('Error updating user:', err);
                    this.$emit('loading', false);
                });
            },
            loading: function(val) {
                this.$emit('loading', val);
            }
        }
    }
</script>
